(function () {
  'use strict';

  var INJECTED_CLASS = 'upcart-compare-subtotal-injected'; // legacy, for cleanup
  var DATA_ATTR = 'data-upcart-compare-subtotal';
  var STYLE_ID = 'upcart-compare-subtotal-style';
  var LOG_PREFIX = '[upcart-compare]';

  // Verbose by default while we wire this up. Flip to false (or set
  // window.UPCART_COMPARE_DEBUG = false) once it's working.
  var DEBUG_DEFAULT = true;
  function logsOn() {
    return window.UPCART_COMPARE_DEBUG !== false &&
           (window.UPCART_COMPARE_DEBUG === true || DEBUG_DEFAULT);
  }
  function debug() {
    if (!logsOn()) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG_PREFIX);
    console.log.apply(console, args);
  }
  function warn() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG_PREFIX);
    console.warn.apply(console, args);
  }

  // ---------- root + shadow-DOM resolution ----------

  // The Upcart drawer is rendered inside an open shadow root attached to
  // <div id="upCart">. The drawer container has id="UpcartPopup" or
  // id="CartPopup". This walks both light DOM and known shadow hosts to
  // locate it.
  function resolveRoot() {
    var direct = document.querySelector('#UpcartPopup, #CartPopup');
    if (direct) return direct;

    var hostCandidates = document.querySelectorAll(
      '#upCart, [id*="upCart" i], [id*="upcart" i], upcart-app, upcart-cart'
    );
    for (var i = 0; i < hostCandidates.length; i++) {
      var host = hostCandidates[i];
      var sr = host.shadowRoot;
      if (!sr) continue;
      var inShadow = sr.querySelector('#UpcartPopup, #CartPopup');
      if (inShadow) return inShadow;
    }
    return null;
  }

  // Styles need to live in the same root as the node we're styling.
  function injectStyleInto(root) {
    var rn = root.getRootNode();
    var host = (rn && typeof ShadowRoot !== 'undefined' && rn instanceof ShadowRoot)
      ? rn
      : document.head;
    if (host.querySelector('#' + STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    // The compare subtotal is rendered as a ::before pseudo-element on the
    // existing subtotal value span. This guarantees it sits directly to the
    // left of the live price, no matter whether the footer uses flex, float,
    // or text-align for its right-side placement.
    style.textContent =
      '[' + DATA_ATTR + ']::before{' +
        'content:attr(' + DATA_ATTR + ');' +
        'text-decoration:line-through;' +
        'opacity:.55;' +
        'font-weight:400;' +
        'font-size:.95em;' +
        'margin-right:8px;' +
        'white-space:nowrap;' +
        'display:inline;' +
      '}';
    host.appendChild(style);
    debug('style injected into', host === document.head ? 'document.head' : 'shadow root');
  }

  // ---------- money helpers ----------

  function parseMoney(text) {
    if (text == null) return null;
    var raw = String(text).replace(/\s+/g, ' ').trim();
    var match = raw.match(/-?[\d.,]+/);
    if (!match) return null;
    var cleaned = match[0];
    var lastDot = cleaned.lastIndexOf('.');
    var lastComma = cleaned.lastIndexOf(',');
    var normalized;
    if (lastComma > lastDot) {
      normalized = cleaned.replace(/\./g, '').replace(',', '.');
    } else {
      normalized = cleaned.replace(/,/g, '');
    }
    var num = parseFloat(normalized);
    return isFinite(num) ? num : null;
  }

  function detectCurrencyTemplate(sampleText) {
    var fallback = { prefix: '$', suffix: ' CAD' };
    if (!sampleText) return fallback;
    var m = String(sampleText).match(/^(\s*[^\d\-]*)(-?[\d.,]+)([^\d]*)$/);
    if (!m) return fallback;
    return { prefix: m[1] || '', suffix: m[3] || '' };
  }

  function formatMoney(amount, template) {
    var fixed = (Math.round(amount * 100) / 100).toFixed(2);
    var parts = fixed.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return template.prefix + intPart + '.' + parts[1] + template.suffix;
  }

  // ---------- per-item extraction ----------

  function getPriceRows(root) {
    return root.querySelectorAll(
      '[class*="upcart-item-prices-row"], [class*="ProductRow__priceRow"]'
    );
  }

  function readUnitPrices(priceRow) {
    var compareEl = priceRow.querySelector(
      '[class*="upcart-item-compare-price"], [class*="upcart-price-compare"], [class*="compareAtPrice"]'
    );
    if (!compareEl) {
      var priceWrap = priceRow.closest('[class*="ProductRow__price"]');
      if (priceWrap) {
        compareEl = priceWrap.querySelector(
          '[class*="upcart-item-compare-price"], [class*="upcart-price-compare"], [class*="compareAtPrice"]'
        );
      }
    }
    var compare = compareEl ? parseMoney(compareEl.textContent) : null;

    var current = null;
    var sample = '';
    var spans = priceRow.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      var s = spans[i];
      var cls = (typeof s.className === 'string' ? s.className : '') ||
                ((s.getAttribute && s.getAttribute('class')) || '');
      if (cls.indexOf('visually-hidden') !== -1) continue;
      if (cls.indexOf('compareAt') !== -1) continue;
      if (cls.indexOf('compare-price') !== -1) continue;
      if (cls.indexOf('price-compare') !== -1) continue;
      if (s.querySelector('span')) continue;
      var txt = (s.textContent || '').trim();
      if (!txt) continue;
      var val = parseMoney(txt);
      if (val != null) { current = val; sample = txt; break; }
    }
    if (!sample && compareEl) sample = compareEl.textContent || '';
    return { compare: compare, current: current, sample: sample, compareEl: compareEl };
  }

  function computeCompareSubtotal(root) {
    var priceRows = getPriceRows(root);
    debug('price rows found:', priceRows.length);
    var total = 0, found = false, sample = '';
    // Upcart's per-item price block already renders the LINE total
    // (unit price * qty), so we just sum each row's amount directly.
    // No qty multiplication here.
    priceRows.forEach(function (pr, idx) {
      var prices = readUnitPrices(pr);
      var amount = prices.compare != null ? prices.compare : prices.current;
      debug('item #' + idx, { compare: prices.compare, current: prices.current, used: amount });
      if (amount != null) {
        total += amount;
        found = true;
        if (!sample && prices.sample) sample = prices.sample;
      }
    });
    return found ? { total: total, sample: sample } : null;
  }

  function getSubtotalEl(root) {
    return root.querySelector(
      '[class*="styles_Footer__cartSubtotalValue"], [class*="cartSubtotalValue"]'
    );
  }

  // ---------- render ----------

  function render(root) {
    // Clean up any legacy sibling spans from earlier versions of this script.
    root.querySelectorAll('.' + INJECTED_CLASS).forEach(function (el) { el.remove(); });

    var subtotalEl = getSubtotalEl(root);
    if (!subtotalEl) {
      debug('no subtotal element yet');
      clearAllCompareAttrs(root);
      return;
    }

    var compareData = computeCompareSubtotal(root);
    var currentSubtotal = parseMoney(subtotalEl.textContent);
    var template = detectCurrencyTemplate(
      subtotalEl.textContent || (compareData && compareData.sample) || ''
    );

    debug('current subtotal:', currentSubtotal,
          'compare total:', compareData && compareData.total);

    if (!compareData || currentSubtotal == null || compareData.total <= currentSubtotal + 0.005) {
      debug('no discount to show; clearing compare attr');
      clearAllCompareAttrs(root);
      return;
    }

    var formatted = formatMoney(compareData.total, template);
    // Clear stale attrs anywhere else (e.g. if subtotalEl got replaced).
    root.querySelectorAll('[' + DATA_ATTR + ']').forEach(function (el) {
      if (el !== subtotalEl) el.removeAttribute(DATA_ATTR);
    });
    if (subtotalEl.getAttribute(DATA_ATTR) !== formatted) {
      subtotalEl.setAttribute(DATA_ATTR, formatted);
      debug('compare subtotal set to', formatted);
    }
  }

  function clearAllCompareAttrs(root) {
    root.querySelectorAll('[' + DATA_ATTR + ']').forEach(function (el) {
      el.removeAttribute(DATA_ATTR);
    });
  }

  // ---------- lifecycle ----------

  var scheduled = false;
  var currentRoot = null;
  var observer = null;

  function schedule() {
    if (scheduled || !currentRoot) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      try { render(currentRoot); } catch (e) { warn('render error', e); }
    });
  }

  function attach() {
    var root = resolveRoot();
    if (!root) return false;
    if (root === currentRoot && observer) return true;
    currentRoot = root;
    if (observer) observer.disconnect();
    observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    injectStyleInto(root);
    debug('attached to root', root, 'in', root.getRootNode() === document ? 'light DOM' : 'shadow DOM');
    schedule();
    return true;
  }

  function init() {
    // Public debug handle
    window.upcartCompareDebug = {
      attach: attach,
      render: function () { if (currentRoot) render(currentRoot); },
      enableLogs: function () { window.UPCART_COMPARE_DEBUG = true; debug('logs enabled'); },
      disableLogs: function () { window.UPCART_COMPARE_DEBUG = false; },
      inspect: function () {
        var root = resolveRoot();
        if (!root) return console.warn(LOG_PREFIX, 'no Upcart root found');
        var rows = getPriceRows(root);
        console.group(LOG_PREFIX, 'inspect (' + rows.length + ' price rows)');
        rows.forEach(function (pr, i) {
          var p = readUnitPrices(pr);
          console.log('#' + i, { priceRow: pr, compare: p.compare, current: p.current });
        });
        console.log('subtotalEl', getSubtotalEl(root));
        console.log('root', root, 'rootNode', root.getRootNode());
        console.groupEnd();
      }
    };

    if (attach()) return;

    debug('root not found yet; setting up bootstrap watchers');

    // Watch light DOM for the shadow host being added/replaced.
    var bootstrap = new MutationObserver(function () { attach(); });
    bootstrap.observe(document.documentElement, { childList: true, subtree: true });

    // A shadow root can be attached AFTER its host element is in the DOM,
    // and there is no DOM event for that, so we also poll for a while.
    var pollCount = 0;
    var poll = setInterval(function () {
      pollCount++;
      if (attach()) {
        clearInterval(poll);
        bootstrap.disconnect();
      } else if (pollCount > 240) { // ~2 min
        clearInterval(poll);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
